import React from 'react'
import { AlertTriangle } from 'lucide-react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    // Aggiorna lo stato per mostrare UI di fallback
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Puoi loggare l'errore a un servizio di reporting
    console.error('ErrorBoundary caught an error:', error, errorInfo)
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    
    // Invia l'errore a Sentry se configurato
    if (window.Sentry) {
      window.Sentry.withScope((scope) => {
        scope.setExtras(errorInfo)
        window.Sentry.captureException(error)
      })
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null })
    // Opzionale: ricarica la pagina per un reset completo
    // window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      // UI di fallback personalizzata
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          background: 'var(--bg)',
          color: 'var(--text)',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center', color: 'var(--orange-ink)' }}><AlertTriangle size={44} strokeWidth={1.6} /></div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, marginBottom: '1rem' }}>
            Qualcosa è andato storto
          </h1>
          <p style={{ color: 'var(--text3)', marginBottom: '2rem', maxWidth: 400 }}>
            Si è verificato un errore nell'applicazione. Puoi provare a ricaricare la pagina o tornare alla dashboard.
          </p>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={this.handleReset}
              style={{
                background: 'var(--primary)',
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: 8,
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Riprova
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                background: 'transparent',
                color: 'var(--text)',
                border: '1px solid var(--border)',
                padding: '0.75rem 1.5rem',
                borderRadius: 8,
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Torna alla Dashboard
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'transparent',
                color: 'var(--text2)',
                border: '1px solid var(--border)',
                padding: '0.75rem 1.5rem',
                borderRadius: 8,
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Ricarica la pagina
            </button>
          </div>
          
          {/* Dettagli errore solo in sviluppo */}
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ 
              marginTop: '2rem', 
              textAlign: 'left', 
              maxWidth: 600,
              background: 'rgba(0,0,0,0.1)',
              padding: '1rem',
              borderRadius: 8,
              fontSize: 12
            }}>
              <summary style={{ cursor: 'pointer', fontWeight: 600 }}>
                Dettagli errore (solo sviluppo)
              </summary>
              <pre style={{ 
                whiteSpace: 'pre-wrap',
                overflowX: 'auto',
                marginTop: '1rem',
                color: '#ef4444'
              }}>
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary